import React, { useState, useEffect } from 'react';
import '../../../styles/trangchu.scss';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, CartesianGrid } from 'recharts';
import Api from '../../../api2';

export default function TrangChu() {
    const [loading, setLoading] = useState(false);
    const [qrData, setQrData] = useState([]);
    const [stats, setStats] = useState([
        { label: 'Cơ sở sản xuất', value: 0, link: '#', color: '#147997' },   
        { label: 'Cơ sở chế biến', value: 0, link: '#', color: '#29aab7' },
        { label: 'Cơ sở phân phối', value: 0, link: '#', color: '#74d2db' },
    ]);
    const [barData, setBarData] = useState([]);
    const [pieData2, setPieData2] = useState([]);

    useEffect(() => {
        setLoading(true);
        new Api().GetThongKeSoLuongQuetQRCode()
            .then(data => {
                if (data && data.code === 200 && Array.isArray(data.data)) {
                    setQrData(data.data.map(item => ({ day: item.ngay, total: item.tongSoLanQuet })));
                } else {
                    setQrData([]);
                }
            })
            .catch(() => setQrData([]))
            .finally(() => setLoading(false));

        // Lấy số lượng các cơ sở
        new Api().GetThongKeSoLuongCoSo()
            .then(data => {
                if (data && data.code === 200 && Array.isArray(data.data)) {
                    setStats([
                        {
                            label: 'Cơ sở sản xuất',
                            value: data.data.find(x => x.tenCoSo === 'Cơ sở sản xuất')?.soLuongCoSo || 0,
                            // link: '#',
                            color: '#147997'
                        },
                        {
                            label: 'Cơ sở chế biến',
                            value: data.data.find(x => x.tenCoSo === 'Cơ sở chế biến')?.soLuongCoSo || 0,
                            // link: '#',
                            color: '#29aab7'
                        },
                        {
                            label: 'Cơ sở phân phối',
                            value: data.data.find(x => x.tenCoSo === 'Cơ sở phân phối')?.soLuongCoSo || 0,
                            // link: '#',
                            color: '#74d2db'
                        }
                    ]);
                }
            });

        // Lấy số lượng lô hàng theo cơ sở phân phối
        new Api().GetThongKeSoLuongLoHangTheoCspp()
            .then(data => {
                if (data && data.code === 200 && Array.isArray(data.data)) {
                    setBarData(data.data.map(item => ({ name: item.tenCoSoPhanPhoi, value: item.soLuongLoHang })));
                } else {
                    setBarData([]);
                }
            });

        // Lấy diện tích sản xuất theo vùng
        new Api().GetThongKeDienTichTheoVungSanXuat()
            .then(data => {
                if (data && data.code === 200 && Array.isArray(data.data)) {
                    const total = data.data.reduce((sum, item) => sum + Number(item.dienTich || 0), 0);
                    setPieData2(
                        data.data.map((item, idx) => ({
                            name: item.tenVungSanXuat,
                            value: Number(item.dienTich || 0),
                            percent: total > 0 ? (Number(item.dienTich || 0) / total * 100) : 0,
                            color: [
                                '#a1887f', '#8d6e63', '#1976d2', '#bcaaa4', '#fbc02d', '#7e57c2', '#8bc34a', '#2b90d9', '#ffc107', '#5cb85c', '#a5d6a7'
                            ][idx % 11]
                        }))
                    );
                } else {
                    setPieData2([]);
                }
            });
    }, []);

    return (
        <div className="body-trangchu" style={{ background: '#f8f9fa', padding: '0 8px 8px 8px' }}>
            <Grid container spacing={1.5}>
                {/* QR code chart + statistic cards */}
                <Grid item xs={12} md={9}>
                    <Box sx={{ background: '#fff', borderRadius: 2, p: '12px 16px 10px 16px', mb: 1.5, boxShadow: 1, minHeight: 316 }}>
                        <div style={{ color: '#24408A', fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Thống kê số lượng quét QR code</div>
                        <div style={{ height: 270 }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={qrData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                                    <XAxis
                                        dataKey="day"
                                        tick={{ fontSize: 12 }}
                                        tickFormatter={v => {
                                            if (!v) return '';
                                            const parts = v.split('-');
                                            return parts.length >= 2 ? `${parts[0]}/${parts[1]}` : v;
                                        }}
                                    />
                                    <YAxis tick={{ fontSize: 12 }} label={{ value: 'Tổng số', angle: -90, position: 'insideLeft', fontSize: 13 }} />
                                    <Tooltip
                                        formatter={(value, name) => [value, name]}
                                        labelFormatter={label => {
                                            if (!label) return '';
                                            const parts = label.split('-');
                                            return parts.length === 3 ? `${parts[0]}/${parts[1]}/${parts[2]}` : label.replace(/-/g, '/');
                                        }}
                                    />
                                    <Legend verticalAlign="top" height={36} />
                                    <Line type="monotone" dataKey="total" name="Tổng số lượt quét" stroke="#40A7DE" strokeWidth={2} dot={{ r: 3 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                    {stats.map((s, idx) => (
                        <Box key={idx} sx={{ background: s.color, color: '#fff', borderRadius: 2, p: 2, mb: 2, minHeight: 90, display: 'flex', flexDirection: 'column', justifyContent: 'center', boxShadow: 1 }}>
                            <div style={{ fontSize: 16, fontWeight: 500 }}>{s.label}</div>
                            <div style={{ fontSize: 28, fontWeight: 700 }}>{s.value}</div>
                        </Box>
                    ))}
                </Grid>
                {/* Pie charts row */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ background: '#fff', borderRadius: 2, p: '12px 16px 10px 16px', boxShadow: 1, minHeight: 370, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ color: '#24408A', fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Số lượng lô hàng</div>
                        <div style={{ height: 220, overflowX: 'auto' }}>
                            <div style={{ minWidth: barData.length > 6 ? barData.length * 120 : '100%', height: '100%' }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={barData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 9, wordBreak: 'break-all' }}
                                            interval={0}
                                            angle={0}
                                            height={80}
                                            tickFormatter={v => {
                                                // Nếu tên dài, cắt thành nhiều dòng (mỗi 18 ký tự xuống dòng)
                                                if (!v) return '';
                                                return v.length > 18 ? v.replace(/(.{18})/g, '$1\n') : v;
                                            }}
                                        />
                                        <YAxis tick={{ fontSize: 12 }} label={{ value: 'Số lượng', angle: -90, position: 'insideLeft', fontSize: 13 }} />
                                        <Tooltip formatter={(value) => value} labelFormatter={label => label} />
                                        <Bar dataKey="value" name="Số lượng lô hàng" fill="#40A7DE" barSize={24} radius={[6, 6, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box sx={{ background: '#fff', borderRadius: 2, p: '12px 16px 10px 16px', boxShadow: 1, minHeight: 370, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ color: '#24408A', fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Diện tích sản xuất theo vùng</div>
                        <div style={{ height: 220 }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie data={pieData2} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={70} innerRadius={40}>
                                        {pieData2.map((entry, idx) => (
                                            <Cell key={`cell2-${idx}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    <Tooltip
                                        formatter={(value, name, props) => {
                                            const percent = props.payload.percent;
                                            return [
                                                `${value.toLocaleString()} m² (${percent.toFixed(1)}%)`,
                                                name
                                            ];
                                        }}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 8, fontSize: 14 }}>
                            {pieData2.map((item, idx) => (
                                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                    <span style={{ width: 12, height: 12, borderRadius: '50%', background: item.color, display: 'inline-block' }}></span>
                                    {item.name}: {item.value.toLocaleString()}m² ({item.percent.toFixed(1)}%)
                                </div>
                            ))}
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}
